import React from 'react'
import {
  PhoneInput as PhoneField,
  PhoneInputRootProps,
  PhoneInputTriggerProps
} from '@tecsinapse/cortex-react'

export const PhoneInput = ({
  onChange,
  value,
  inputProps,
  phoneInputProps
}: {
  onChange?: (
    value: string,
    rest: {
      inputValue: string
      country: any
    }
  ) => void
  value?: string
  inputProps?: PhoneInputTriggerProps
  phoneInputProps?: PhoneInputRootProps
}) => {
  return (
    <PhoneField.Root
      onChange={onChange}
      value={value}
      defaultCountry='br'
      {...phoneInputProps}
    >
      <PhoneField.Trigger {...inputProps} />
      <PhoneField.Popover>
        <PhoneField.Options hasSearch={false} />
      </PhoneField.Popover>
    </PhoneField.Root>
  )
}
